import { timeout, delay } from '@ynap/promise-utils';
import { ResponseError, Person } from '@ynap/api-utils';
import { UPDATE_USER_REQUEST, UPDATE_USER_SUCCESS, UPDATE_USER_ERROR } from '../constants/ActionTypes';
import setUpdateUserSuccess from './setUpdateUserSuccess';
import { push } from 'connected-react-router';

function updateUserEmailRequest() {
    return {
        type: UPDATE_USER_REQUEST,
    };
}

function updateUserEmailSuccess(user) {
    return {
        type: UPDATE_USER_SUCCESS,
        body: user,
    };
}

function updateUserEmailError(error) {
    return {
        type: UPDATE_USER_ERROR,
        error,
    };
}

export default function updateUserEmail(user) {
    return (dispatch, getState, fetch) => {
        const { uberToken, locale, config, router } = getState();
        const { country } = locale;
        const { location = {} } = router;
        const { pathname } = location;
        const { clientRequest } = config.head || config;
        const { baseUrl, clientId, clientSecret } = config.watsonService || config.global.services.commerce;
        const { brandId } = config.watsonService || config.global.application;
        const userPayload = { ...user, email1: user.logonId };

        const request = Person.userUpdate({
            baseUrl,
            brandId,
            country,
            user: userPayload,
            uberToken,
            clientId,
            clientSecret,
            options: locale.langISO ? { locale: locale.langISO } : undefined,
        });

        const redirect = `/${locale.id}/account/details`;

        dispatch(updateUserEmailRequest());

        return delay(timeout(fetch(request), clientRequest.timeout), clientRequest.delay)
            .then((response) => {
                const { ok, status } = response;

                if (ok) {
                    return response
                        .json()
                        .then(() => dispatch(updateUserEmailSuccess(user)))
                        .then(() => dispatch(push(redirect)))
                        .then(() => dispatch(setUpdateUserSuccess('changeEmail')));
                } else if (status === 401) {
                    return dispatch(push(`/${locale.id}/account/login?redirect=${pathname}`));
                }

                throw new ResponseError(response);
            })
            .catch((error) => {
                dispatch(updateUserEmailError(error));
                throw error;
            });
    };
}
